import type { SkillDef } from "../types";
import { digits, fmt, nz, placeParts, prob } from "../util";

const SPEC: Record<number, [[number, number], [number, number]]> = {
  1: [[2, 5], [2, 9]], 2: [[2, 9], [2, 12]], 3: [[2, 9], [13, 50]], 4: [[2, 9], [51, 99]],
  5: [[2, 9], [100, 999]], 6: [[11, 19], [2, 20]], 7: [[11, 25], [11, 60]], 8: [[12, 99], [11, 99]],
  9: [[12, 99], [100, 999]], 10: [[101, 999], [11, 99]],
};

export const div: SkillDef = {
  key: "div", name: "Division", blurb: "exact, chunked", start: 1,
  generate(L, r) {
    const [[dl, dh], [ql, qh]] = SPEC[L];
    const d = r.int(dl, dh), q = r.int(ql, qh), parts = placeParts(q);
    let hint = "Chunk it: " + parts.map((p) => `${fmt(d)}×${fmt(p)} = ${fmt(d * p)}`).join(", ");
    hint += parts.length > 1 ? `\n→ ${parts.map(fmt).join(" + ")} = ${fmt(q)}` : ` → ${fmt(q)}`;
    const t = q <= 12 && d <= 9 ? 3 : 2 + 2.5 * nz(q) * digits(d);
    return prob(`${fmt(d * q)} ÷ ${fmt(d)}`, q, hint, { t });
  },
};
